import React, { SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Fancybox } from '../../../../../../shared/components/Fancybox';
import { UploadImage } from '../../../../../../shared/components/UploadImage';
import { IReportItems } from '../../../../../brand/campaign/manage/calendar/dto/IManageCalendar';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { formatDate } from '../../../../../../shared/functions/Functions';
import { IReportingUpdate } from '../../ReportingCampaignCard';
import { BsFillTrashFill } from 'react-icons/bs';
import { IPicture } from '../../../../../../model/shared/IPicture';
import { Row } from 'react-bootstrap';
import { PlannerStatusEnum } from '../../../../../../enum/PlannerStatusEnum';
import TooltipOverlay from '../../../../../../shared/components/tooltip/Tooltip';

interface Props {
    reportItems: IReportItems[];
    setUpdateData: React.Dispatch<SetStateAction<IReportingUpdate>>;
    status: string;
    setSelectedFile?: React.Dispatch<SetStateAction<IPicture>>;
    fileKey?: string;
    isButtonDisabled?: boolean;
    errorFile?: boolean;
    isVerified?: boolean;
}

const ReportingScreenshots = ({
    reportItems,
    isButtonDisabled = false,
    setUpdateData,
    status,
    setSelectedFile,
    fileKey = 'file',
    errorFile,
    isVerified,
}: Props) => {
    const { t } = useTranslation();
    const [files, setFiles] = useState<Blob[] | MediaSource[]>();

    useEffect(() => {
        if (files) {
            setUpdateData(prev => ({ ...prev, [fileKey]: files }));
        }
    }, [files]);

    return (
        <div>
            <h5>{t('influencer.reporting.reportingScreenshots')}</h5>
            <span className={`${errorFile ? 'text-danger' : 'text-muted'}`}>
                {t('influencer.reporting.reportingScreenshotsDescription')}
            </span>
            <Row>
                <div className="col-md-4 my-2">
                    <UploadImage
                        disabled={isButtonDisabled}
                        saveFile={setFiles}
                        isDeleteHidden={true}
                        isMultiple={true}
                        isSmall
                        error={errorFile}
                        acceptedFormats="image/jpeg, image/png, image/jpg"
                        classes="px-0"
                        maxFiles={50}
                    />
                </div>
                <Fancybox>
                    <div className="row">
                        {reportItems?.map(reportImages => (
                            <React.Fragment key={reportImages?.id}>
                                {reportImages?.reportImages?.map(file => (
                                    <div className="col-md-4 my-2" key={file?.id}>
                                        <div className={`content-files-card border-primary px-3`}>
                                            <Row className={'py-2 p-md-0'}>
                                                <div className="col-4">
                                                    <div
                                                        data-fancybox={`gallery-${reportImages?.id}`}
                                                        className="cursor-pointer"
                                                        data-src={
                                                            file?.externalLink ??
                                                            file?.reportPath ??
                                                            '/icons/filePlaceholder.png'
                                                        }
                                                    >
                                                        <CustomImageHandler
                                                            classes="card-img cursor-pointer shadow-lg default-radius-sm"
                                                            photoPath={file?.reportPath as string}
                                                            thumbnailPath={file?.thumbnail as string}
                                                            altTag="Campaign image"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-8 pl-0">
                                                    <div className="p-2 p-md-0 d-flex flex-column align-items-end justify-content-between h-100">
                                                        <div className="d-flex flex-column w-100">
                                                            <TooltipOverlay
                                                                content={
                                                                    <span className="word-brake">
                                                                        {file?.title ?? '-'}
                                                                    </span>
                                                                }
                                                            >
                                                                <span className="text-truncate">
                                                                    {file?.title ?? '-'}
                                                                </span>
                                                            </TooltipOverlay>
                                                            <span className="text-muted">
                                                                {formatDate(file?.createdAt)}
                                                            </span>
                                                        </div>
                                                        {/* status === undefined means it's additional */}
                                                        {((status === PlannerStatusEnum.REPORTED && !isVerified) ||
                                                            status === undefined) && (
                                                            <BsFillTrashFill
                                                                className="text-muted cursor-pointer font-20"
                                                                onClick={() => {
                                                                    if (setSelectedFile) {
                                                                        setSelectedFile(file);
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </Row>
                                        </div>
                                    </div>
                                ))}
                            </React.Fragment>
                        ))}
                    </div>
                </Fancybox>
            </Row>
        </div>
    );
};

export default ReportingScreenshots;
